/**
 * Manage the Google Address suggestions and autocomplete address fields
 */
(function (root, factory) {
	if ( typeof define === 'function' && define.amd ) {
		define([], factory(root));
	} else if ( typeof exports === 'object' ) {
		module.exports = factory(root);
	} else {
		root.BrasilAPIAddressAutocomplete = factory(root);
	}
})(typeof global !== 'undefined' ? global : this.window || this.global, function (root) {

	'use strict';

	var $ = jQuery;

	var _hasJQuery = ( $ != null );
	var _hasInitialized = false;
	var _hasCheckoutBlock = false;
	var _publicMethods = { };
	var _settings = {
		bodyClass:                                  'has-brasil-api-autocomplete',
		
		formRowSelector:                            '.form-row, .wc-block-components-text-input, .wc-block-components-country-input, .wc-block-components-state-input',
		countryToStateSelector:                     'select.country_to_state, input.country_to_state',
		stateToCitySelector:                        'select.state_to_city, input.state_to_city',
		formRowExpansibleSelector:                  '.form-row.fc-expansible-form-section',
		formRowExpansibleToggleSelector:            '#fc-expansible-form-section__toggle--###FIELD_ID###',
		formRowExpansibleContentSelector:           '#fc-expansible-form-section__content--###FIELD_ID###',
		addressGroupSelector:                       '.woocommerce-shipping-fields, .woocommerce-billing-fields, .woocommerce-address-fields, .wc-block-components-address-form',
		addressGroupShippingSelector:               '.woocommerce-shipping-fields, #shipping.wc-block-components-address-form',
		addressGroupBillingSelector:                '.woocommerce-billing-fields, #billing.wc-block-components-address-form',
		addressFieldsSelector:                      '[name$="address_1"], [name$="address_2"], [name$="neighborhood"], [name$="city"], [name$="state"]',

		select2Selector:                            '[class*="select2"]',
		enhancedSelectFieldsSelector:               '.fc-select2-field select',

		postcodeFieldSelector:                      '#postcode, #billing_postcode, #shipping_postcode, #billing-postcode, #shipping-postcode',
		countryFieldSelector:                       '#country, #billing_country, #shipping_country, #billing-country, #shipping-country',

		brasilApiURL:                               'https://brasilapi.com.br/api/cep/v1/{cep}',

		// Keys based on WooCommerce forms field ids, values based on component names from Brasil API data values
		localeComponents: {
			state: 'state',
			city: 'city',
			address_1: 'street',
			neighborhood: 'neighborhood',
		},

		debugMode:                                  false,
	};
	var _lastPostcodeValue;
	var _placesCache = {};


	/**
	 * METHODS
	 */



	/*!
	 * Merge two or more objects together.
	 * (c) 2017 Chris Ferdinandi, MIT License, https://gomakethings.com
	 * @param   {Boolean}  deep     If true, do a deep (or recursive) merge [optional]
	 * @param   {Object}   objects  The objects to merge together
	 * @returns {Object}            Merged values of defaults and options
	 */
	var extend = function () {
		// Variables
		var extended = {};
		var deep = false;
		var i = 0;

		// Check if a deep merge
		if ( Object.prototype.toString.call( arguments[0] ) === '[object Boolean]' ) {
			deep = arguments[0];
			i++;
		}

		// Merge the object into the extended object
		var merge = function (obj) {
			for (var prop in obj) {
				if (obj.hasOwnProperty(prop)) {
					// If property is an object, merge properties
					if (deep && Object.prototype.toString.call(obj[prop]) === '[object Object]') {
						extended[prop] = extend(extended[prop], obj[prop]);
					} else {
						extended[prop] = obj[prop];
					}
				}
			}
		};

		// Loop through each object and conduct a merge
		for (; i < arguments.length; i++) {
			var obj = arguments[i];
			merge(obj);
		}

		return extended;
	};



	/**
	 * Reduce postcode to only numbers.
	 *
	 * @param   string       postcode  The CEP/Postcode field value.
	 */
	var getUnformattedPostcode = function( postcode ) {
		return postcode.replace( /[^0-9]/, '' );
	}



	/**
	 * Set address field value.
	 *
	 * @param   {HTMLElement}    field  Form field.
	 * @param   {Object}         value  Value to set for the form field.
	 */
	var setFieldValue = function( field, value ) {
		// Bail if field not provided
		if ( ! field ) { return; }
		
		// Sanitize value
		value = value == undefined || value == null ? '' : value;

		// Set field value
		field.value = value;
		field.setAttribute( 'data-fallback-value', value );

		// Set field value for select2 fields
		if ( _hasJQuery && field.matches( _settings.select2Selector ) ) {
			$( field ).val( value );
			$( field ).trigger( 'change.select2' );

			// Maybe log event
			if ( 'yes' == _settings.debugMode ) {
				console.log( 'Event `change.select2` triggered.' );
				console.log( field );
			}
		}

		// Set field value for FC enhanced select fields
		if ( field.matches( _settings.enhancedSelectFieldsSelector ) && field.tomselect ) {
			field.tomselect.setValue( value, true );

			// Maybe log event
			if ( 'yes' == _settings.debugMode ) {
				console.log( 'Enhanced select: updated selected value silently.' );
			}
		}

		// Maybe set value for equivalent hidden field
		if ( 'yes' === _settings.maybeSetHiddenFields ) {
			var hiddenFieldSelector = _settings.hiddenFieldSelectorTemplate.replace( '###FIELD_NAME###', field.name );
			var hiddenField = document.querySelector( hiddenFieldSelector );
			if ( hiddenField ) {
				hiddenField.value = value;

				// Maybe log event
				if ( 'yes' == _settings.debugMode ) {
					console.log( 'Hidden field `' + field.name + '`: ' + value );
				}
			}
		}

		// Maybe trigger `change` event for country to state fields
		if ( _hasJQuery && field.matches( _settings.countryToStateSelector ) ) {
			$( field ).trigger( 'change' );

			// Maybe log event
			if ( 'yes' == _settings.debugMode ) {
				console.log( 'Event `change` triggered for country to state field.' );
				console.log( field );
			}
		}

		// Maybe trigger `change` event for state to city fields
		if ( _hasJQuery && field.matches( _settings.stateToCitySelector ) ) {
			$( field ).trigger( 'change' );

			// Maybe log event
			if ( 'yes' == _settings.debugMode ) {
				console.log( 'Event `change` triggered for state to field field.' );
				console.log( field );
			}
		}

		// Try to expand or collapse optional fields
		if ( window.CollapsibleBlock && field.closest( _settings.formRowExpansibleSelector ) ) {
			var formRow = field.closest( _settings.formRowExpansibleSelector );
			var fieldCollapsibleToggle = formRow.querySelector( _settings.formRowExpansibleToggleSelector.replace( '###FIELD_ID###', field.id ) );
			var fieldCollapsibleContent = formRow.querySelector( _settings.formRowExpansibleContentSelector.replace( '###FIELD_ID###', field.id ) );

			// Maybe expand field content section
			var hasValue = null !== value && '' !== value;
			if ( hasValue ) {
				CollapsibleBlock.collapse( fieldCollapsibleToggle, false ); // Collapse without transitions
				CollapsibleBlock.expand( fieldCollapsibleContent, false, false ); // Expand without transitions and without setting focus
			}
			// Otherwise field content section
			else {
				CollapsibleBlock.expand( fieldCollapsibleToggle, false, false ); // Expand without transitions and without setting focus
				CollapsibleBlock.collapse( fieldCollapsibleContent, false ); // Collapse without transitions
			}
		}

		// Clear validation status
		// If Fluid Checkout checkout validation script is available
		if ( window.CheckoutValidation ) {
			CheckoutValidation.clearValidationResults( field, field.closest( _settings.formRowSelector ) );
		}

		// Trigger field `validate` event
		if ( _hasJQuery ) {
			$( field ).trigger( 'validate' );
		}
	}



	/**
	 * Clear address form fields
	 * 
	 * @param   {HTMLElement}    groupElement  Element containing the address form field.
	 */
	var cleanAddressFields = function( groupElement ) {
		// Bail if address book element not passed
		if ( ! groupElement ) { return; }

		window.can_update_checkout = false;

		// Maybe set value for the WooCommerce Checkout Block address
		if ( _hasCheckoutBlock ) {
			var setAddressValueMethod = groupElement.matches( _settings.addressGroupShippingSelector ) ? 'setShippingAddress' : 'setBillingAddress';
			var dataObject = { address_1: '', address_2: '', city: '', state: '' };
			wp.data.dispatch( 'wc/store/cart' )[ setAddressValueMethod ]( dataObject );
		}
		// Otherwise reset field values directly
		else {
			// Iterate address form fields
			var fields = groupElement.querySelectorAll( _settings.addressFieldsSelector );
			for ( var i = 0; i < fields.length; i++ ) {
				var field = fields[i];
				setFieldValue( field, '' );
			}
		}
		
		window.can_update_checkout = true;
	}



	/**
	 * Get the value for an address field from the Google Place data based on the locale.
	 *
	 * @param   {string}  fieldId  Form field id to get data for.
	 * @param   {Object}  place    Google Place data
	 * @param	{string}  locale   Country code of the locale.
	 *
	 * @return  {string}           Localized value for the form field.
	 */
	var getFieldValueFromPlace = function( fieldId, place ) {
		// Bail if place not valid
		if ( ! place ) { return; }
		
		// Get `localeComponents` as an Array
		var locale = _settings.localeComponents;
		var placeField = locale[ fieldId ];

		return place[ placeField ];
	}



	/**
	 * Fill address form field values for a place from Google Place API.
	 *
	 * @param   {Object}                            place          Google Place data.
	 * @param   {HTMLElement}                       input          Address lookup field element.
	 */
	var fillAddressFields = function( place, input ) {
		var groupElement = input.closest( _settings.addressGroupSelector );
		var addressTypePrefix = groupElement.matches( _settings.addressGroupShippingSelector ) ? 'shipping-' : 'billing-';

		// Clear previous address field values
		cleanAddressFields( groupElement );

		// Initialize data object for WooCommerce Checkout Block
		var dataObject = new Object();

		// Set address field values to the selected place
		var fieldIds = Object.getOwnPropertyNames( _settings.localeComponents );
		for ( var i = 0; i < fieldIds.length; i++ ) {
			var fieldId = fieldIds[ i ];
			
			// Skip country and postcode fields
			if ( fieldId == 'country' || fieldId == 'postcode' ) { continue; }

			// Get field and value
			var field = groupElement.querySelector( 'input[id$="'+fieldId+'"], textarea[id$="'+fieldId+'"], select[id$="'+fieldId+'"], #'+addressTypePrefix+fieldId+' input' );

			// Skip if field was not found
			if ( ! field ) { continue; }
			
			// Get field value
			var value = getFieldValueFromPlace( fieldId, place );

			// Set state field value to uppercase to match values from WooCommerce
			if ( fieldId == 'state' && ( field.type.indexOf( 'select' ) > -1 )  ) { value = value.toUpperCase(); }

			// Maybe log field details
			if ( 'yes' == _settings.debugMode ) {
				console.log( fieldId + ': ' + value );
				console.log( field );
			}

			// Maybe push field value to the data object
			// for setting the address for WooCommerce Checkout Block
			if ( _hasCheckoutBlock ) {
				dataObject[ fieldId ] = value;
			}
			// Otherwise set field value
			else {
				setFieldValue( field, value );
			}
		}

		// Maybe set value for the WooCommerce Checkout Block address
		if ( _hasCheckoutBlock ) {
			var setAddressValueMethod = input.closest( _settings.addressGroupShippingSelector ) ? 'setShippingAddress' : 'setBillingAddress';
			wp.data.dispatch( 'wc/store/cart' )[ setAddressValueMethod ]( dataObject );
		}

		// Trigger checkout update event
		if ( _hasJQuery ) {
			$( document.body ).trigger( 'update_checkout' );

			// Maybe log
			if ( 'yes' == _settings.debugMode ) {
				console.log( 'Update checkout triggered' );
			}
		}
	}



	/**
	 * Subit address data request to Brasil API and process results.
	 *
	 * @param   string       postcode  The CEP/Postcode field value.
	 * @param   HTMLElement  input     The postcode input element.
	 */
	var maybeSubmitBrasilApiDataRequest = function( postcode, input ) {
		// Bail if jQuery not available
		if ( ! _hasJQuery ) { return; }

		// Maybe use values from local cache
		if ( _placesCache[ '_' + postcode ] ) {
			// Fill address values
			var place = _placesCache[ '_' + postcode ];
			fillAddressFields( place, input );

			// Finish function
			return;
		}

		// Retrive data from API
		$.ajax({
			type:		'GET',
			url:		_settings.brasilApiURL.replace( '{cep}', postcode ),
			success:	function( response ) {
				var place = JSON.parse( response );

				// Maybe log place details
				if ( 'yes' == _settings.debugMode ) {
					console.log( place );
				}

				// Fill address values
				fillAddressFields( place, input );

				// Update cache
				_placesCache[ '_' + postcode ] = place;
			},
			dataType: 'html'
		});
	}


	
	/**
	 * Maybe call function to retrive address data when postcode and country are supported.
	 *
	 * @param   Event  e  Keyup event data dispatched on the postcode input field.
	 */
	var maybeSetInitialLastPostcodeValue = function( e ) {
		// Bail if last postcode value is already set
		if ( _lastPostcodeValue ) { return; }

		var input = e.target;
		var postcode = getUnformattedPostcode( input.value );
		_lastPostcodeValue = postcode;
	}


	/**
	 * Maybe call function to retrive address data when postcode and country are supported.
	 *
	 * @param   Event  e  Keyup event data dispatched on the postcode input field.
	 */
	var maybeAutofillAddress = function( e ) {
		var input = e.target;
		var postcode = getUnformattedPostcode( input.value );
		var groupElement = input.closest( _settings.addressGroupSelector );
		var countryField = groupElement.querySelector( _settings.countryFieldSelector );
		var addressTypePrefix = groupElement.matches( _settings.addressGroupShippingSelector ) ? 'shipping_' : 'billing_';

		// Bail if country field not set to Brazil, continue if country field not found, inferring that it only sells to Brazil
		if (
			( ! _hasCheckoutBlock && countryField && 'BR' !== countryField.value ) // Shortcode based checkout
			|| ( _hasCheckoutBlock && ! ( window.wcSettings && 'BR' === wcSettings.checkoutData[ addressTypePrefix + 'address' ].country ) ) // WooCommerce Checkout Block
		) { return; }

		// Bail if postcode format is invalid
		if ( ! postcode || postcode.length != 8 ) { return; }

		// Submit data request if postcode value has changed
		if ( postcode !== _lastPostcodeValue ) {
			_lastPostcodeValue = postcode;
			maybeSubmitBrasilApiDataRequest( postcode, input );
		}
	}


	/**
	 * Handle captured `focus` event and route to the appropriate functions.
	 *
	 * @param   {Event}  e  Event dispatched. Usually `focus` or `focusin`.
	 */
	var handleFocus = function( e ) {
		if ( e.target.matches( _settings.postcodeFieldSelector ) ) {
			maybeSetInitialLastPostcodeValue( e );
		}
	}

	/**
	 * Handle captured `keydown` event and route to the appropriate functions.
	 *
	 * @param   {Event}  e  Keydown event dispatched.
	 */
	var handleKeyup = function( e ) {
		if ( e.target.matches( _settings.postcodeFieldSelector ) ) {
			maybeAutofillAddress( e );
		}
	}



	/**
	 * Initialize component and set related handlers.
	 * 
	 * @param   {Object}   options  Pass different settings values for initializing this component.
	 */
	_publicMethods.init = function( options ) {
		if ( _hasInitialized ) return;

		// Try to get options from the plugin settings JS object
		if ( ! options && window.fcGAASettings && window.fcGAASettings.brasilAPISettings ) {
			options = window.fcGAASettings.brasilAPISettings;
		}

		// Merge settings
		_settings = extend( true, _settings, options );

		// // Add event listeners
		window.addEventListener( 'focusin', handleFocus );
		window.addEventListener( 'keyup', handleKeyup, true );

		// Determine if using WooCommerce Checkout Block
		if ( document.querySelector( 'body:not( .has-fluid-checkout ) [data-block-name="woocommerce/checkout"]' ) ) {
			_hasCheckoutBlock = true;
		}

		// Finish initialization
		document.body.classList.add( _settings.bodyClass );
		_hasInitialized = true;
	};



	//
	// Public APIs
	//
	return _publicMethods;

});
